import prettier from 'prettier';
import liquidParser from 'prettier-plugin-liquid';

export const formatHTML = (source) => {
  let output = source;

  try {
    output = prettier.format(source, {
      liquidSingleQuote: false,
      parser: 'liquid-html',
      plugins: [liquidParser]
    });
  } catch (e) {
    console.error(e);
  }

  return output;
};

export const minifyHTML = (html) => html.replace(/\s+/g, ' ').replace(/>\s+</g, '><');
